import Vue from 'vue';
import Vuex from 'vuex';
import {AscDesc, ResultType, XHTTPService} from '@/shared/xhttp';
import {
	PaginatorActionWithFilters,
	PaginatorFilterState,
	PaginatorMutation,
	StandardAction
} from '@/shared/utils';
import {LongueursVente} from '@/models';
import {LongueursVenteService} from "@/xhttp";
import store from '@/stores';

Vue.use(Vuex);

export class LongueursVenteFilter {
	
	public name: string = '';
	
	public toString(): string {
		return JSON.stringify(this);
	}
}

class LongueursVenteState extends PaginatorFilterState<LongueursVenteFilter> {
	public longueursVente: LongueursVente = null;
	public longueursVentes: ResultType<LongueursVente> = null;
	public longueursVentesAll: ResultType<LongueursVente> = null;
	public constructor() {
		super(new LongueursVenteFilter(), 'longueursVentes', 'longueursVente', 'listOrder', AscDesc.ASC, 50);
	}
}

class LongueursVenteStore {
	
	@XHTTPService(() => LongueursVente)
	private longueursVenteService: LongueursVenteService;
	
	public state: LongueursVenteState = new LongueursVenteState();
	
	public mutations = {
		...PaginatorMutation(() => storeLongueursVente, 'longueursVentes', 'longueursVente'),
	};
	
	public actions = {
		...StandardAction<LongueursVente, LongueursVenteState>(() => LongueursVente, 'longueursVente'),
		...PaginatorActionWithFilters<LongueursVente, LongueursVenteState>(() => LongueursVente, 'longueursVentes', 'longueursVente'),
	};
	
}
const instance = new LongueursVenteStore();
const storeLongueursVente = new Vuex.Store(instance);
store.registerModule('longueursVente', storeLongueursVente);
export default storeLongueursVente;
